import type { IconProps } from "@/types/icon";

const CrossIcon24 = ({
    width = 24,
    height = 24,
    fill = "#F2F2F2",
    ...remainingProps
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        {...remainingProps}
    >
        <path
            d="M6.66602 17.3334L17.3327 6.66675M6.66602 6.66675L17.3327 17.3334"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="square"
            strokeLinejoin="round"
        />
    </svg>
);

export default CrossIcon24;
